import React, { useEffect, useState } from "react";
import { loadAdminRevenue } from "../../hooks/useAdminRevenue";
import HostLayout from "../../layouts/HostLayout";
import StripeConnectSetup from "../StripeConnectSetup";

export default function AdminRevenueDashboard() {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await loadAdminRevenue();
        setData(res);
      } catch (e) {
        setErr(e?.message ?? "Failed to load");
      }
    })();
  }, []);

  if (err) return <HostLayout><div className="p-6 text-red-600">Error: {err}</div></HostLayout>;
  if (!data) return <HostLayout><div className="p-6 text-gray-600">Loading…</div></HostLayout>;

  const { orders, baseTotal, creatorShare, platformBase, softwareFees, refunds } = data;

  return (
    <HostLayout>
      <div className="max-w-6xl mx-auto p-6 space-y-6">
        <h1 className="text-2xl font-semibold text-gray-900">TriviaPlug Admin Dashboard</h1>
        
        {/* TriviaPlug Stripe Connect Setup */}
        <div className="bg-gray-800 rounded-lg p-6">
          <h2 className="text-xl font-semibold text-white mb-4">Platform Payment Account</h2>
          <p className="text-gray-300 mb-4">
            Set up TriviaPlug's payment account to receive platform revenue from marketplace sales.
          </p>
          <StripeConnectSetup />
        </div>

        {/* Revenue Overview */}
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Revenue Overview (last 24h)</h2>
          <div className="grid gap-4 sm:grid-cols-3">
            <Tile label="Orders" value={orders} />
            <Tile label="Base Total" value={toUSD(baseTotal)} />
            <Tile label="Creator Share" value={toUSD(creatorShare)} />
            <Tile label="Platform Base" value={toUSD(platformBase)} />
            <Tile label="Software Fees" value={toUSD(softwareFees)} />
            <Tile label="Refunds" value={toUSD(refunds)} />
          </div>
        </div>
      </div>
    </HostLayout>
  );
}

function Tile({ label, value }) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <div className="text-xs uppercase tracking-wide text-gray-500 font-medium">{label}</div>
      <div className="mt-2 text-xl font-semibold text-gray-900">{value}</div>
    </div>
  );
}

function toUSD(cents) {
  const dollars = (cents ?? 0) / 100;
  return dollars.toLocaleString(undefined, { style: "currency", currency: "USD" });
}
